import { useEffect } from "react";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import Button from "@vapor/react-material/Button";
import Stack from "@vapor/react-material/Stack";
import { Link } from "react-router-dom";
import { TSLogo, NotFoundImage } from "../../images";
import { useLayout } from "../state/use-layout";

export const PageNotFound = () => {
  const { isEmbed, setIsEmbed } = useLayout();

  useEffect(() => {
    setIsEmbed(true);
  }, [isEmbed]);

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ p: "32px", gap: "16px", flex: "1" }}
    >
      <TSLogo />
      <NotFoundImage />
      <ExtendedTypography
        variant="display"
        gutterBottom
        component="div"
        color="primary.textTitleColor"
      >
        404
      </ExtendedTypography>
      <ExtendedTypography
        variant="body1"
        gutterBottom
        color="primary.textTitleColor"
      >
        We can't find the page you are looking for
      </ExtendedTypography>
      <Link to="/" style={{ textDecoration: "none" }}>
        <Button
          variant="contained"
          onClick={() => setTimeout(() => setIsEmbed(false), 100)}
        >
          Go Back to Home
        </Button>
      </Link>
    </Stack>
  );
};
